// Веб-вклад модуля `weak-spots` — слабые места.
//
// Стоит в первичной навигации рядом с Обучением: это пробелы из курсов и
// тестов, а не «ещё один инструмент».

import { SECTION_CATEGORY, SECTION_ICONS } from "@/components/navigation/section-icons";
import { belongsToLiveMaterial } from "@/lib/powersync/live-material-sql";
import type { WebModuleManifest } from "./_contract";

export const weakSpotsWebManifest = {
	id: "weak-spots",
	icon: SECTION_ICONS.weakSpots,
	labelKey: "nav.weakSpots",
	category: SECTION_CATEGORY.weakSpots,
	routes: ["/weak-spots"],

	// Баннер объясняет МЕХАНИКУ: название раздела не говорит ни откуда пробелы
	// берутся, ни что с ними делать (волна 1, `docs/copy/ONBOARDING-COPY.md` §8.1).
	// Вкладка справки — «Метод»: слабые места и есть шаг ③ «Добрать».
	intro: {
		titleKey: "weak-spots:intro.title",
		bodyKey: "weak-spots:intro.body",
		bulletKeys: [
			"weak-spots:intro.bullets.0",
			"weak-spots:intro.bullets.1",
			"weak-spots:intro.bullets.2",
		],
	},

	nav: [
		{
			key: "weak-spots",
			to: "/weak-spots",
			icon: SECTION_ICONS.weakSpots,
			labelKey: "nav.weakSpots",
			order: 30,
			// Пробел без материала-владельца жив, пробел удалённого материала — нет.
			// Предикат ОБЩИЙ со списком раздела (`use-mastery-by-topic-query.ts`):
			// пока копий было две, бейдж уменьшался, а список — нет.
			badge: {
				kind: "powersync",
				sql: `SELECT count(*) FROM weak_spots w
					WHERE w.user_id = ? AND ${belongsToLiveMaterial("w")}`,
			},
		},
	],
} satisfies WebModuleManifest;
